/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { IframeWrap } from '@styles/base.style'
import Iframe from 'react-iframe'

export interface NewsPopupProps {
  link?: string
}

const NewsPopup: React.FC<NewsPopupProps> = (props => {
  const { link } = props

  return (
    <IframeWrap className="modal">
      <Iframe
        url={link}
        scrolling="yes"
        width="100%"
        frameBorder={0}
      />
    </IframeWrap>
  )
})

export default observer(NewsPopup)
